import React from 'react';
import {FormattedMessage} from 'react-intl';
import {INSTAGRAM_CHANNEL, TELEGRAM_SUPPORT} from '../../constants';
import {LinkButton} from '../../components/button/button';
import MainCareersIcon from '../../assets/main-careers.svg';
import './careers.scss';

const HomeCareers = () => {
    return (
        <div className='home-careers'>
            <div className='display-flex flex-direction-column mw768-flex-direction-row column-gap-4rem row-gap-4rem mw768-padding-left-2rem mw768-padding-right-2rem'>
                <div className='mw768-flex-1 align-self-center'>
                    <p className='display-sm mw768-display-md semibold color-gray-900'>
                        <FormattedMessage defaultMessage='Open vacancies'/>
                    </p>
                    <p className='padding-top-1rem mw768-padding-top-1dot25rem text-lg mw768-text-xl color-gray-500'>
                        <FormattedMessage defaultMessage='At Ottry, we bring together talented people who are passionate about doing more. Join our team and create a culture of innovation and opportunity with us.'/>
                    </p>
                    <div className='display-flex flex-direction-column-row padding-top-2rem mw768-padding-top-2dot5rem column-gap-0dot75rem row-gap-0dot75rem'>
                        <LinkButton link={{target: '_blank', rel: 'noopener noreferrer', href: TELEGRAM_SUPPORT}} color='primary-gradient' size='xl' fluid='mobile'>
                            <FormattedMessage defaultMessage='We are hiring!'/>
                        </LinkButton>
                        <LinkButton link={{target: '_blank', rel: 'noopener noreferrer', href: INSTAGRAM_CHANNEL}} color='secondary-gray' size='xl' fluid='mobile'>
                            <FormattedMessage defaultMessage='About company'/>
                        </LinkButton>
                    </div>
                </div>
                <div className='mw768-flex-1'>
                    <MainCareersIcon className='position-relative left-50percent transform-translateX-center'/>
                </div>
            </div>
        </div>
    )
};

export default React.memo(HomeCareers);